import type { ReactNode } from 'react'
import { SlotContext } from './dashboardViewControlsSlotCore'

export const DashboardViewControlsSlotProvider = ({
  slotEl,
  children,
}: {
  slotEl: HTMLElement | null
  children: ReactNode
}) => (
  <SlotContext.Provider value={slotEl}>{children}</SlotContext.Provider>
)
